<template>
  <div class="modal fade" id="FAQAddModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered w-[800px]  ">
          <Form class="w-full" @submit="onSubmit" :validation-schema="schema">

              <div class="modal-content w-full">
                  <div class="modal-header">
                      <h1 class="modal-title fs-5">Create New FAQ</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body ">
                      <div class="overflow-hidden">
                          <div class="float-left p-2 h-20 w-full">
                              Question:
                              <v-text-field v-model="question" variant="outlined" density="compact"
                                  rounded="0"></v-text-field>
                          </div>
                          <div class="float-left p-2 w-full">
                              Answer:
                              <v-textarea v-model="answer" variant="outlined" density="compact"
                                  rounded="0"></v-textarea>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                      <button type="submit" :disabled="buttonDisableFlag" class="btn btn-primary">Add</button>
                  </div>
              </div>
          </Form>

      </div>
  </div>
</template>



<script setup>
import { ref, defineEmits, defineProps } from "vue";
import { useFAQStore } from "@/stores";
import { Form } from 'vee-validate';
const props = defineProps({
    count: {
        type: Number,
        required: true
    }
})
const answer = ref("");
const question = ref("");


const buttonDisableFlag = ref(false)
const emit = defineEmits(['inInput', 'submit'])

const faqStore = useFAQStore();

const onSubmit = () => {
    const createRequest = {
        answer: answer.value,
        question: question.value,
        count: props.count
    };
    buttonDisableFlag.value = true
    faqStore.addFAQ(createRequest).then(() => {
        buttonDisableFlag.value = false
        emit('updated')
    });
};

</script>
<style>
.v-textarea .v-field--no-label textarea, .v-textarea .v-field--active textarea {
    font-size: 12px;
}
</style>